/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARewindBackIcon16Solid = forwardRef('MediaUiARewindBackIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.939 2.989.594 6.849a1.42 1.42 0 0 0 0 2.302l5.345 3.86c.86.621 2.061.007 2.061-1.053V9.444l4.939 3.567c.86.621 2.061.007 2.061-1.053V4.043c0-1.061-1.201-1.675-2.061-1.054L8 6.556V4.043c0-1.061-1.201-1.675-2.061-1.054Z" })));
});
